import { isEmpty } from 'lodash'
import React from 'react'
import { Card, CardBody, CardHeader, Table } from 'reactstrap'
import NoDataComponent from '../NoDataComponent'
const EntityAuditorDetails = ({auditorDetails}) => {
  return (
    <React.Fragment>
        <Card style={{border:"none"}}>
            <CardHeader>
            <div className="d-flex align-items-end">
                        <h4>Governance</h4>
                    </div>
            </CardHeader>
            <CardBody className='m-0 p-0'>
            {!isEmpty(auditorDetails) ? <div className="table-responsive">
                <Table >
                    <thead>
                        <tr>
                            <th scope="col">Auditor</th>
                            <th scope="col">Audit Firm</th>
                            <th scope="col">Year</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isEmpty(auditorDetails) && auditorDetails.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td>{item.auditorOrMemberName || 'N/A'}</td>
                                    <td>{item.auditorFirmName || 'N/A'}</td>
                                    <td>{item.year || 'N/A'}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </div> : <NoDataComponent title='No Data' subtitle='No Data Available' />}
            </CardBody>
        </Card>
    </React.Fragment>
  )
}

export default EntityAuditorDetails